/* ============================================================
   TCG Rarity Effects — runtime
   - Persiste el estado del toggle en localStorage ('tcgFx')
   - Sincroniza el checkbox #tcg-fx-toggle
   - Holo por posición del puntero (--mx/--my) + leve tilt 3D
   - Respeta prefers-reduced-motion (sin tilt ni seguimiento)
   ============================================================ */
(function () {
  'use strict';

  var STORAGE_KEY = 'tcgFx';
  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(pointer: fine)').matches;

  function fxEnabled() {
    return !root.classList.contains('tcg-fx-off');
  }

  function setFx(on) {
    root.classList.toggle('tcg-fx-off', !on);
    try { localStorage.setItem(STORAGE_KEY, on ? 'on' : 'off'); } catch (e) {}
    document.querySelectorAll('#tcg-fx-toggle').forEach(function (cb) { cb.checked = on; });
  }

  // Inicializa el/los toggles con el estado actual y escucha cambios.
  function initToggles() {
    document.querySelectorAll('#tcg-fx-toggle').forEach(function (cb) {
      cb.checked = fxEnabled();
      cb.addEventListener('change', function () { setFx(cb.checked); });
    });
  }

  // Modo oscuro (2026-10-01). El <head> ya puso data-tema antes de pintar;
  // aquí solo se sincroniza el botón de la cabecera y se guarda la elección.
  // Por defecto la tienda es CLARA (es su identidad); el oscuro se elige.
  function initTema() {
    var btns = document.querySelectorAll('[data-tcg-tema]');
    if (!btns.length) return;
    function pinta() {
      var oscuro = root.getAttribute('data-tema') === 'oscuro';
      btns.forEach(function (b) {
        b.setAttribute('aria-pressed', oscuro ? 'true' : 'false');
        b.setAttribute('aria-label', oscuro ? 'Volver al modo claro' : 'Activar modo oscuro');
        b.title = oscuro ? 'Modo claro' : 'Modo oscuro';
      });
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var oscuro = root.getAttribute('data-tema') !== 'oscuro';
        if (oscuro) root.setAttribute('data-tema', 'oscuro'); else root.removeAttribute('data-tema');
        try { localStorage.setItem('tcgTema', oscuro ? 'oscuro' : 'claro'); } catch (e) {}
        pinta();
      });
    });
    pinta();
  }

  // Seguimiento del puntero para el brillo holográfico + tilt.
  // Las cartas tienen capa .tcg-holo; otros elementos ([data-tcg-tilt]) solo reciben tilt suave.
  var raf = null;
  function onMove(e) {
    if (!fxEnabled() || reduceMotion) return;
    var card = e.currentTarget;
    var rect = card.getBoundingClientRect();
    var px = (e.clientX - rect.left) / rect.width;   // 0..1
    var py = (e.clientY - rect.top) / rect.height;   // 0..1
    var amp = card.hasAttribute('data-tcg-tilt') ? 7 : 18;
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () {
      var holo = card.querySelector('.tcg-holo');
      if (holo) {
        holo.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
        holo.style.setProperty('--my', (py * 100).toFixed(1) + '%');
      }
      card.style.setProperty('--rx', ((px - 0.5) * amp).toFixed(2) + 'deg');
      card.style.setProperty('--ry', ((0.5 - py) * amp).toFixed(2) + 'deg');
    });
  }
  function onEnter(e) {
    if (!fxEnabled() || reduceMotion || !finePointer) return;
    e.currentTarget.classList.add('tcg-tilt');
  }
  function onLeave(e) {
    var card = e.currentTarget;
    card.classList.remove('tcg-tilt');
    card.style.removeProperty('--rx');
    card.style.removeProperty('--ry');
  }

  function bindCard(card) {
    if (card.dataset.tcgBound) return;
    card.dataset.tcgBound = '1';
    card.addEventListener('pointermove', onMove);
    card.addEventListener('pointerenter', onEnter);
    card.addEventListener('pointerleave', onLeave);
  }

  function bindAll(scope) {
    (scope || document)
      .querySelectorAll('.tcg-card[data-rarity]:not([data-rarity="none"]), [data-tcg-tilt]')
      .forEach(bindCard);
  }

  // Parallax suave del hero: --tcg-parallax = fracción del hero ya scrolleada (0..1).
  // Solo desktop, con FX activos y sin reduced-motion.
  function initParallax() {
    if (reduceMotion) return;
    var hero = document.querySelector('.tcg-hero');
    if (!hero) return;
    var mql = window.matchMedia('(min-width: 750px)');
    var ticking = false;
    function update() {
      ticking = false;
      if (!fxEnabled() || !mql.matches) {
        hero.style.removeProperty('--tcg-parallax');
        return;
      }
      var rect = hero.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, -rect.top / (rect.height || 1)));
      hero.style.setProperty('--tcg-parallax', p.toFixed(4));
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  // Fondo ambiental (tcg-sistema.css, "AMBIENTE"): las capas animadas de cada
  // escena se pausan cuando la escena sale de pantalla. Sin esto, una portada
  // con quince secciones mantenía treinta animaciones vivas a la vez.
  function initAmbiente() {
    if (!('IntersectionObserver' in window)) return;
    var sel = '.tcg-home, .tcg-quiz, .tcg-mercado, .tcg-eventos, .tcg-cta--paper, .tcg-horario, .tcg-rev, .tcg-launch, .tcg-contact-wrap, .tcg-top';
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.classList.toggle('tcg-amb-off', !e.isIntersecting); });
    }, { rootMargin: '120px 0px' });
    document.querySelectorAll(sel).forEach(function (el) { io.observe(el); });
  }

  function init() {
    initToggles();
    initTema();
    bindAll(document);
    initParallax();
    initAmbiente();
    // Re-vincula cuyos cards lleguen por AJAX (filtros/paginación de Crave).
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { bindAll(document); break; }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
